import { ComponentsLayout } from './layout'

export const CardsPage = () => {
  return (
    <ComponentsLayout 
      title="Cards" 
      description="Componentes de cartão para exibição de conteúdo"
    >
      <div className="text-center py-16">
        <div className="max-w-md mx-auto">
          <div className="bg-white p-8 rounded-lg shadow-sm border">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Em Desenvolvimento
            </h3>
            <p className="text-gray-600 mb-6">
              Os componentes de Cards estão sendo desenvolvidos e estarão disponíveis em breve.
            </p>
            <div className="text-sm text-gray-500">
              🔧 Componente em construção
            </div>
          </div>
        </div>
      </div>
    </ComponentsLayout>
  )
}
